import client from '../../client';

const SALES_INTERESTS = {
  getSalesInterests() {
    return client.get(`/buyers/${client.customerId()}/sales`);
  }
}

export default SALES_INTERESTS;
